import { useEffect, useState } from 'react'
import { AdjustColumns, Hr } from '../../styles'
import { Button, Form, Modal } from 'react-bootstrap'
import callApi from '../../../../helpers/callapi'
import config from '../../../../config'
import Cookies from 'js-cookie'
import CONSTANTS from '../../../../constants/constants'

const Customer = ({ userInfo }) => {
  const { fullName, userNo, phone, lineId, userId } = userInfo || {}
  const [lineUsername, setLineUsername] = useState('')
  const [ownerBankName, setOwnerBankName] = useState('')
  const [ownerBankNo, setOwnerBankNo] = useState('')
  const [isShowLineChat, setIsShowLineChat] = useState(false)

  const bank = Object.keys(CONSTANTS.banks).map((key) => (ownerBankName === key ? CONSTANTS.banks[key] : null))
  const bankName = bank.filter((s) => s !== null)

  function handleOnClickSendLineMessage(lineId) {
    const elLineMessage = document.querySelector('#line_message')
    if (lineId) {
      callApi({
        url: '/linebot/newChat',
        body: { message: elLineMessage.value, lineId: lineId },
      })
        .then((res) => console.log(res))
        .catch((err) => console.log(err))
    }
    setIsShowLineChat(false)
  }

  useEffect(() => {
    let cancel = false

    const getUserInfo = async () => {
      try {
        const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/users/${userId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        })
        const json = await response.json()
        if (json.status.code === 0 && !cancel) {
          setLineUsername(json.data.name)
          setOwnerBankName(json.data.ownerBankName)
          setOwnerBankNo(json.data.ownerBankNo)
        }
      } catch (error) {
        console.error(error)
      }
    }

    if (lineId) getUserInfo()

    return () => {
      cancel = true
    }
  }, [lineId, userId])

  return (
    <>
      <h4>ข้อมูลลูกค้า</h4>
      <Hr />
      <AdjustColumns>
        <div>ชื่อลูกค้า</div>
        <div>
          {fullName ? fullName : '-'}
          <span className="text-success" style={{ cursor: 'pointer' }} onClick={() => setIsShowLineChat(true)}>
            &nbsp;(เปิดแชทไลน์)
          </span>
        </div>
      </AdjustColumns>
      <AdjustColumns>
        <div>รหัสลูกค้า</div>
        <div>{userNo ? userNo : '-'}</div>
      </AdjustColumns>
      <AdjustColumns>
        <div>เบอร์โทร</div>
        <div>{phone ? phone : '-'}</div>
      </AdjustColumns>
      <AdjustColumns>
        <div>เบอร์บัญชีธนาคารลูกค้า</div>
        <div>
          {bankName ? bankName : '-'} {ownerBankNo ? ownerBankNo : '-'}
        </div>
      </AdjustColumns>
      <Modal show={isShowLineChat} onHide={() => setIsShowLineChat(false)} centered>
        <Modal.Header>ทักแชทไลน์</Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Label>
              ชื่อลูกค้า : {fullName ? fullName : '-'}&nbsp;
              {lineUsername && `(${lineUsername})`}
            </Form.Label>
            <Form.Control
              as="textarea"
              id="line_message"
              rows={3}
              className="mt-2"
              placeholder="ข้อความที่ต้องการส่ง"
            />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={() => setIsShowLineChat(false)}>
            ยกเลิก
          </Button>
          <Button variant="primary light" onClick={() => handleOnClickSendLineMessage(lineId ? lineId : null)}>
            ส่งข้อความ
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default Customer
